import React, { useState } from "react";
import queryString from "query-string";
import { GochiKidBannerDetailModal } from "./GochiKidBannerDetailModal";
import MenuService from "../../../../api/services/MenuService";
import {
  SURVEY_TYPE,
  SURVEY_QUESTION_TYPE,
} from "../../../../constants";
import { HTTP_API } from "../../../../api/HttpClient";
import { GochiKidSurveyModal } from "./GochiKidSurveyModal";
import { GochiKidSurveyGroupUserResultModal } from "./GochiKidSurveyGroupUserResultModal";

export function GochiKidListBannerModal(props) {
  const [bannerDetail, setBannerDetail] = useState(null);
  const [showBannerDetail, setShowBannerDetail] = useState(false);
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [showSurveyResultModal, setShowSurveyResultModal] = useState(false);

  const [surveyDetails, setSurveyDetails] = useState(null);
  const questions = surveyDetails?.questions || [];
  const [answers, setAnswers] = useState([]);
  const [isPass, setIsPass] = useState(false);
  const accessCode = queryString.parse(window.location.search).accessCode;
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [messageErrorModal, setMessageErrorModal] = useState("");

  const handleOpenBannerDetail = (detail) => {
    setBannerDetail(detail);
    setShowBannerDetail(true);
    props.handleClose(false);
  };

  const handleCloseBannerDetail = () => {
    setShowBannerDetail(false);
    props.handleClose(true);
  };

  const handleOpenGochiKidSurvey = async () => {
    props.setLoading(true);

    try {
      const params = {
        gochiGroupId: bannerDetail?.gochiKidGroupId,
        surveyType: 4,
      };
      const response = await MenuService.getSurvey(params);

      if (response.status === HTTP_API.SUCCESS) {
        setSurveyDetails(response.data);
        const qs = response.data.questions || [];
        let initialAnwsers = {};

        for (let i = 0; i < qs.length; i++) {
          if (qs[i].questionType === SURVEY_QUESTION_TYPE.TEXT) {
            initialAnwsers[i] = "";
          } else if (qs[i].questionType === SURVEY_QUESTION_TYPE.RADIO) {
            initialAnwsers[i] = "";
          } else if (qs[i].questionType === SURVEY_QUESTION_TYPE.CHECKBOX) {
            initialAnwsers[i] = new Set();
          } else if (qs[i].questionType === SURVEY_QUESTION_TYPE.IMAGE) {
            initialAnwsers[i] = new Set();
          }
        }

        setAnswers(initialAnwsers);
        setShowSurveyModal(true);
        setShowBannerDetail(false);
      } else {
        alert(
          "フォームの表示に失敗しました。前画面に戻って、もう一度やり直してください。",
        );
      }
    } catch (e) {
      console.log(e);
      alert(
        "フォームの表示に失敗しました。前画面に戻って、もう一度やり直してください。",
      );
    } finally {
      props.setLoading(false);
    }
  };

  const handleCloseGochiKidSurvey = () => {
    setShowBannerDetail(true);
    setShowSurveyModal(false);
    setSurveyDetails(null);
    setAnswers([]);
  };

  const handleSubmitGochiKidSurvey = async (answer) => {
    props.setLoading(true);

    try {
      const response = await MenuService.postSurveyAnswerGochiKidGroupUser(
        surveyDetails.surveyId,
        answer,
      );

      if (response.status === HTTP_API.SUCCESS) {
        setIsPass(response.data.applyFlag === 1);
        setShowSurveyResultModal(true);
        setShowSurveyModal(false);
        setSurveyDetails(null);
        setAnswers([]);
      } else if (response.status === HTTP_API.ERROR_CONFLICT) {
        setMessageErrorModal("本資金グループに参加しました。");
        setShowSurveyModal(false);
        setShowErrorModal(true);
        setSurveyDetails(null);
        setAnswers([]);
        setBannerDetail(null);
      } else {
        setMessageErrorModal("現在、このモニターに応募できません。");
        setShowSurveyModal(false);
        setShowErrorModal(true);
        setSurveyDetails(null);
        setAnswers([]);
        setBannerDetail(null);
      }
    } catch (e) {
      console.log(e);
      setMessageErrorModal("エラーが発生しました");
      setShowSurveyModal(false);
      setShowErrorModal(true);
      setSurveyDetails(null);
      setAnswers([]);
      setBannerDetail(null);
    } finally {
      props.setLoading(false);
    }
  };

  const handleCloseSurveyResult = async () => {
    setShowSurveyResultModal(false);
    props.setLoading(true);
    const userId =
      props.userInfo.userId ||
      (accessCode && Number(window.atob(accessCode).slice(0, -2)));
    await props.getUserKidData(userId);
    props.setLoading(false);
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  }

  return (
    <>
      <div
        className={
          props.showing
            ? "custom-modal-container group-special-gochi-kid-modal list-gochi-kid-banner-modal show-modal"
            : "custom-modal-container group-special-gochi-kid-modal"
        }
        size="sm"
      >
        <div
          className={
            props.showing
              ? "modal modal-action modal-dialog is-show history-modal max-width-335"
              : "modal modal-action modal-dialog history-modal max-width-335"
          }
        >
          <div className="modal-header-history">
            <button
              className="modal-btn modal-btn-close"
              id="modalClose"
              onClick={() => props.handleClose(false)}
              type="button"
            >
              <svg className="icon">
                <title>閉じる</title>
                <use xlinkHref="/assets/img/common/icon.svg#times" />
              </svg>
            </button>
          </div>
          <div className="title-modal title-modal-charge">
            <div className="title">モニター募集一覧</div>
            {props.listGochiKidBanner?.length > 0 && (
              <div className="note">下にスクロールすると続きが見られます。</div>
            )}
          </div>
          <div className={`modal-body`}>
            {props.listGochiKidBanner?.length > 0 ? (
              props.listGochiKidBanner?.map((item, index) => {
                return (
                  <div
                    className={`group-special-box mb-24px`}
                    key={item.gochiKidGroupId}
                  >
                    <div className="group-name">{item.gochiKidGroupName}</div>
                    {item.applyFlag !== null && (
                      <div className="status-container">
                        <span className="status-box label">応募済み</span>
                        <span
                          className={`status-box ${item.applyFlag == 1 ? "status-pass" : "status-fail"}`}
                        >
                          {item.applyFlag == 1
                            ? "結果：ご当選"
                            : "結果：お見送り"}
                        </span>
                      </div>
                    )}
                    <div className="description">{item.description}</div>
                    <div>
                      <button
                        onClick={() => handleOpenBannerDetail(item)}
                        className="btn btn-rect btn-submit w-100 mt-16px fs-16"
                      >
                        詳細を見る
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="mb-24px">データがありません。</div>
            )}
          </div>
        </div>
        <div
          onClick={() => props.handleClose(false)}
          className={`back-drop ${
            props.accessToken && props.accessCode ? "back-drop-bold" : ""
          }`}
        />
      </div>

      <GochiKidBannerDetailModal
        showing={showBannerDetail}
        handleClose={handleCloseBannerDetail}
        bannerDetail={bannerDetail}
        handleOpenGochiKidSurvey={handleOpenGochiKidSurvey}
      />

      {showSurveyModal && (
        <GochiKidSurveyModal
          showing={showSurveyModal}
          onClose={handleCloseGochiKidSurvey}
          questions={questions}
          answers={answers}
          setAnswers={setAnswers}
          surveyDetails={surveyDetails}
          handleSubmitGochiKidSurvey={handleSubmitGochiKidSurvey}
          gochiKidSurveyType={SURVEY_TYPE.GOCHI_KID_GROUP_USER}
        />
      )}

      <GochiKidSurveyGroupUserResultModal
        showing={showSurveyResultModal}
        bannerDetail={bannerDetail}
        isPass={isPass}
        handleClose={handleCloseSurveyResult}
      />

      {showErrorModal && (
        <div
          className={
            showErrorModal
              ? "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal gochi-kid-upload-receipt-error gochi-kid-receipt-error show-modal"
              : "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal gochi-kid-upload-receipt-error gochi-kid-receipt-error"
          }
          size="sm"
        >
          <div
            className={
              showErrorModal
                ? "modal modal-action modal-dialog is-show history-modal"
                : "modal modal-action modal-dialog history-modal"
            }
          >
            <div className="modal-header-history">
              <button
                className="modal-btn modal-btn-close"
                id="modalClose"
                onClick={() => {
                  handleCloseErrorModal();
                }}
                type="button"
              >
                <svg className="icon">
                  <title>閉じる</title>
                  <use xlinkHref="/assets/img/common/icon.svg#times" />
                </svg>
              </button>
            </div>
            <div className={`modal-body`}>{messageErrorModal}</div>
            <div className="modal-footer">
              <button
                className="btn btn-rect btn-submit"
                onClick={() => {
                  handleCloseErrorModal();
                }}
              >
                マイページに戻る
              </button>
            </div>
          </div>
          <div className={`back-drop`} />
        </div>
      )}
    </>
  );
}
